import { getNamedAnalysis } from "routes/sfg20-admin/plugins/system-info/activity-tab/controller/get-named-analysis"
import React from "react"
import { AnalysisTable } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/analysis-table"
import { getGraphStyles } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/graph-styles"
import { Grid2, Paper } from "@mui/material"

export function FileNotFound({ reportDuration, granularity }) {
    const data =
        getNamedAnalysis.useResults("metric-summary", reportDuration, granularity, {
            event: "404",
            metrics: [{ metric: "path", jsonPath: "path" }],
        }) ?? {}

    if (!data.results) {
        const { size, graphPaperSx, graphGridSx } = getGraphStyles()
        return (
            <Grid2 size={size} sx={graphGridSx}>
                <Paper elevation={3} sx={graphPaperSx}>
                    Loading
                </Paper>
            </Grid2>
        )
    }

    return (
        <AnalysisTable
            title={`404 Errors - Last ${reportDuration} day(s)`}
            data={data.results}
            columns={[
                { field: "path", size: 8 },
                { field: "recordCount", size: 4 },
            ]}
        />
    )
}
